<template>
  <div class="map-hot-container">
    <div id="map-hot"></div>
    <div class="ranking-box">
      <div class="title">全国城市TOP10排行</div>
      <template v-if="rankingList.length > 0">
        <div class="ranking-item" v-for="(item, index) in rankingList" :key="'ranking' + index">
          <div class="ranking-index">{{index + 1}}</div>
          <div class="rankig-info">
            <div>{{item.name}}</div>
            <div>{{item.value}}万吨</div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import mapData from '../js/MapHot'
import { getWeightHeat } from '../../../api/colunm2'
export default {
  data () {
    return {
      option: mapData.option,
      rankingData: mapData.mapData,
      Chart: null,
      timer: null
    }
  },

  computed: {
    rankingList () {
      const data = this.rankingData
      data.sort((a, b) => {
        return b.value - a.value
      })
      return data.slice(0, 10)
    }
  },

  created () {
    
  },

  mounted () {
    this.getData()
  },

  methods: {
    getData () {
      getWeightHeat().then(res => {
        console.log(res)
        const tempData = []
        res.forEach(element => {
          element.value = Number(element.value.toFixed(2))
          tempData.push(element)
        })
        this.option.series[0].data = [ ...tempData ]
        this.rankingData = res
        this.option.visualMap.max = this.rankingData.length !== 0 ? this.rankingData[0].value : 50
        this.myEcharts()
        this.timer && clearInterval(this.timer)
        this.timer = setTimeout(this.getData, 1000 * 5)
      })
    },

    myEcharts () {
      if (this.Chart) {
        this.Chart.setOption(this.option)
      } else {
        this.Chart = this.$echarts.init(document.getElementById("map-hot"))
        this.Chart.setOption(this.option)
        const app = {
          currentIndex: -1
        }
        setInterval(() => {
          const dataLen = this.option.series[0].data.length;
          // 取消之前高亮的图形
          // this.Chart.dispatchAction({
          //   type: 'downplay',
          //   seriesIndex: 0,
          //   dataIndex: app.currentIndex
          // })
          app.currentIndex = (app.currentIndex + 1) % dataLen
          //console.log(app.currentIndex);
          // 高亮当前图形
          this.Chart.dispatchAction({
            type: 'highlight',
            seriesIndex: 0,
            dataIndex: app.currentIndex,
          })
          // 显示 tooltip
          this.Chart.dispatchAction({
            type: 'showTip',
            seriesIndex: 0,
            dataIndex: app.currentIndex
          })
        }, 1000 * 10)
      }
    },

    value (value) {
      return Number(value).toFixed(2)
    }
  }
}
</script>

<style lang="less" scoped>
.map-hot-container {
  display: flex;
  width: 648px;
  height: 420px;
  #map-hot {
    width: 400px;
    height: 420px;
  }
  .ranking-box {
    width: 248px;
    height: 100%;
    padding: 60px 40px 0 42px;
    color: #fff;
    .title {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 10px;
    }
    .ranking-item {
      display: flex;
      align-items: center;
      font-size: 15px;
      margin-bottom: 5px;
      .ranking-index {
        width: 20px;
        height: 20px;
        margin-right: 12px;
        border-radius: 50%;
        color: #000;
        font-size: 14px;
        font-family: "SourceHanSerifCN-Heavy";
        text-align: center;
        line-height: 20px;
        background: #FFF;
      }
      .rankig-info {
        flex-grow: 1;
        display: flex;
        justify-content: space-between;
        color: RGBA(212, 213, 217, 1);
        font-family: 'SourceHanSansCN-Normal';
      }
    }
    .ranking-item:nth-child(2) {
      .ranking-index {
        width: 25px;
        height: 21px;
        margin-right: 7px;
        border-radius: 0;
        line-height: 25px;
        background: transparent;
        background-image: url('../../../assets/image/ranking1.png');
        background-size: 100% 100%;
      }
    }
    .ranking-item:nth-child(3) {
      .ranking-index {
        width: 25px;
        height: 21px;
        margin-right: 7px;
        border-radius: 0;
        line-height: 25px;
        background: transparent;
        background-image: url('../../../assets/image/ranking2.png');
        background-size: 100% 100%;
      }
    }
    .ranking-item:nth-child(4) {
      .ranking-index {
        width: 25px;
        height: 21px;
        margin-right: 7px;
        border-radius: 0;
        line-height: 25px;
        background: transparent;
        background-image: url('../../../assets/image/ranking3.png');
        background-size: 100% 100%;
      }
    }
  }
}
</style>